import React from 'react';
import { FiExternalLink, FiGithub } from 'react-icons/fi';
import './Projects.css';

const Projects = () => {
  const projects = [
    // 2026-06-13 archived — ClarityCart removed from portfolio
    // {
    //   id: 1,
    //   title: 'ClarityCart - E-commerce AI Chatbot',
    //   description: 'AI-powered chatbot for e-commerce using LLMs to enhance customer service and product recommendations',
    //   technologies: ['Python', 'LLM', 'FastAPI', 'React'],
    //   github: 'https://github.com/ClarityCart-Dev/shopifyembeddedapp',
    //   highlights: ['NLP Integration', 'Real-time Chat', 'Product Search']
    // },
    {
      id: 6,
      title: 'BlinkGuard - Driver Drowsiness Detection System',
      description: 'BlinkGuard is a real-time driver drowsiness detection system built with MediaPipe, OpenCV, Python, and the Google Maps API. It processes 30+ FPS live webcam input to track blink rate, eye closure duration, and head movement for fatigue detection, using adaptive gamma correction and pose-aware nose tracking to surface real-time driver safety metrics in the UI. I used Fetch.ai agents to build adaptive alert logic that adjusts detection thresholds based on each user\'s calibration data, behavior, and fatigue signals over time, enabling personalized safety monitoring across a full-stack mobile deployment.',
      technologies: ['MediaPipe', 'OpenCV', 'Python', 'Fetch.ai', 'Google Maps API'],
      github: 'https://github.com/DanielM7852/blinkguard',
      demo: 'https://blinkguard-one.vercel.app/',
      highlights: ['Computer Vision', 'Agentic AI', 'Real-time Detection', 'Adaptive ML', 'Biometric Analysis']
    },
    {
      id: 5,
      title: 'CarbinWatcher - AI-Powered Smart Waste Classification System',
      description: 'Built during a hackathon, CarbinWatcher is a live waste sorting system that uses an Arduino Q, Logitech webcam, YOLOv8, and C++ to classify items into trash, recycling, or compost in real time. The system integrates Google Gemini AI for local regulation compliance and privacy-preserving edge processing, with models trained via NVIDIA Brev.dev. I also engineered an AWS cloud pipeline using IoT Core, S3, and DynamoDB that feeds a DataBricks ETL workflow to train ML models forecasting CO2 emissions reduction, and integrated MiDaS monocular depth estimation for volume tracking. The project earned 3rd Place for Best Use of Cloud and Best Models Trained on Impulse.',
      technologies: ['YOLOv8', 'Arduino Q', 'AWS', 'Google Gemini', 'C++', 'DataBricks'],
      github: 'https://github.com/DanielM7852/carbinwatch-final',
      demo: 'https://carbinwatcher-dashboard.vercel.app/',
      highlights: ['Edge AI', 'Computer Vision', 'IoT', 'Cloud Pipeline', '3rd Place Winner']
    },
    {
      id: 4,
      title: 'EntangleDR',
      description: 'EntangleDR Lab is a full-stack research platform built with Python, FastAPI, Next.js, scikit-learn, and yfinance for comparing correlation-aware dimensionality reduction against PCA, Kernel-PCA, and no-DR baselines on equity signals. It combines a FastAPI pipeline with purged time-series cross-validation, transaction-cost backtests, bootstrap confidence intervals, and significance testing with a Next.js UI featuring interactive EntangleDR hyperparameter sliders, Recharts visualizations, and CSV export. I formalized EntangleDR using Givens rotations on correlated technical features, ran multi-ticker benchmark studies across 29 S&P names, and drafted a working paper with reproducible experiment manifests planned for publication in Summer 2027.',
      technologies: ['Python', 'FastAPI', 'Next.js', 'scikit-learn', 'yfinance', 'Recharts'],
      github: 'https://github.com/DanielM7852/Quantam-Dimensionality-Reduction-for-Portfolio-Optimization',
      demo: 'https://quantam-dr-entangle.vercel.app/',
      highlights: ['Dimensionality Reduction', 'Quantitative Finance', 'Backtesting', 'Research Platform']
    },
    {
      id: 2,
      title: 'NFL Big Data Bowl 2026',
      description: 'Built for the NFL Big Data Bowl, this red zone analytics project identifies optimal play strategies using player kinematic tracking data. I joined input, output, and supplementary datasets and engineered features including ball catch position, closest defender distance, and defender alignment relative to the targeted receiver. I calculated receiver acceleration from frame-by-frame displacement, identified touchdowns through string matching, and binned results into 5-yard intervals from 5 to 20 yards from the end zone. Statistical testing showed defender proximity and front-side alignment significantly affected catch rates. I estimated touchdown probabilities using a Bayesian prior updated with observed outcomes and Monte Carlo simulation.',
      technologies: ['Python', 'Pandas', 'NumPy', 'Matplotlib', 'Seaborn', 'SciPy'],
      github: 'https://github.com/DanielM7852/NFL-Redzone-Analytics',
      demo: '#',
      highlights: ['Red Zone Analytics', 'Coach Dashboard', 'Bayesian Modeling', 'Monte Carlo Simulation']
    },
    {
      id: 3,
      title: 'BigDataView',
      description: 'During my Data Science internship at Boeing, I collaborated with a mentor and a multi-disciplinary engineering team to create a Python visualization tool for multi-dimensional hypersonic and plane trajectory data. BigDataView uses Python, Matplotlib, JSON, and more to convert complex 5 or more dimensional data into comprehensive 2-D dashboards using nested heatmaps.',
      technologies: ['Python', 'Matplotlib', 'JSON', 'Data Visualization'],
      github: 'https://github.com/DanielM7852/BigDataView',
      demo: '#',
      highlights: ['7D Data Visualization', 'Heatmaps', 'Surface Plots']
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Projects</h2>
        <p className="section-subtitle">Selected work in machine learning, data science, and software development</p>

        <div className="projects-grid">
          {projects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-header">
                <h3 className="project-title">{project.title}</h3>
                <div className="project-links">
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                      <FiGithub size={20} />
                    </a>
                  )}
                  {project.demo && project.demo !== '#' && (
                    <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link">
                      <FiExternalLink size={20} />
                    </a>
                  )}
                </div>
              </div>

              <p className="project-description">{project.description}</p>

              <div className="project-highlights">
                {project.highlights.map((highlight, i) => (
                  <span key={i} className="highlight-tag">{highlight}</span>
                ))}
              </div>

              <div className="project-tech">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
